import StrictObj from './strict-obj'
import debugFields from './debug-fields'

import MyIsotopeMasonry from './my-isotope-masonry'
import MyIsotopeCarousel from './my-isotope-carousel'

export default function MyIsotopeProxy(
  transitionDuration,
  carouselModeGetter,
  isoGridContentElm,
  isoGridShowcaseElm,
  carouselNextElm,
  carouselPrevElm,
  descDiffPairs,
  highlightPeriod,
  castToX1,
  castToX2,
  getMasonrySizerWidth,
  getCarouselSizerHeight,
  getMasonryWidth,
  getCarouselHeight,
  getCarouselWidth,
  flowHeadInViewportHandler,
  flowTailInViewportHandler) {

  const methods = [
    'pairs',
    'contains',
    'scrollTo',
    'silentMode',
    'animateMode',
    'currentMode',
    'appendSilent',
    'removeSilent',
    'removeVirtual',
    'arrange',
    'prepend',
    'resize',
    'append',
    'remove'
  ]

  let target = null
  let isInitialized = false
  let isCarouselMode = null

  const proxy = StrictObj(debugFields({
    init,
    active,
    destroy,
    getTarget,
    switchType
  }, {
    _carouselModeGetter: carouselModeGetter,
    _isoGridContentElm: isoGridContentElm,
    _isoGridShowcaseElm: isoGridShowcaseElm,
    _carouselNextElm: carouselNextElm,
    _carouselPrevElm: carouselPrevElm,
    _descDiffPairs: descDiffPairs,
    _highlightPeriod: highlightPeriod,
    _castToX1: castToX1,
    _castToX2: castToX2,
    _getMasonrySizerWidth: getMasonrySizerWidth,
    _getCarouselSizerHeight: getCarouselSizerHeight,
    _getMasonryWidth: getMasonryWidth,
    _getCarouselHeight: getCarouselHeight,

    _methods: methods,
    _defineMethod: defineMethod,

    _initialized: () => isInitialized,
    _carouselMode: () => isCarouselMode
  }))

  methods.forEach(defineMethod)

  return proxy

  function init() {
    if (!isInitialized) {
      isInitialized = true
      switchType()
    }
    return proxy
  }

  function destroy() {
    if (target) {
      isCarouselMode = null
      target.destroy()
      target = null
    }
    return proxy
  }

  function active() {
    return !!target
  }

  function getTarget() {
    return target
  }

  function switchType() {
    if (isCarouselMode === carouselModeGetter()) {
      return proxy
    }

    isCarouselMode = carouselModeGetter()

    const existPairs = target
      ? target.pairs()
      : null

    if (target) {
      target.destroy()
    }

    if (isCarouselMode) {
      target = MyIsotopeCarousel(
        transitionDuration,
        isoGridContentElm,
        isoGridShowcaseElm,
        carouselNextElm,
        carouselPrevElm,
        descDiffPairs,
        highlightPeriod,
        castToX1,
        castToX2,
        getCarouselSizerHeight,
        getCarouselHeight,
        getCarouselWidth,
        flowHeadInViewportHandler,
        flowTailInViewportHandler)
    } else {
      target = MyIsotopeMasonry(
        transitionDuration,
        isoGridContentElm,
        descDiffPairs,
        highlightPeriod,
        castToX1,
        castToX2,
        getMasonrySizerWidth,
        getMasonryWidth)
    }

    if (existPairs) {
      target.appendSilent(existPairs)
    }

    return proxy
  }

  function defineMethod(name) {
    proxy[name] = debugFields(proxy_method, {
      _name: name
    })

    function proxy_method() {
      return target[name].apply(null, arguments)
    }
  }
}
